<div class="empty-page" *ngIf="_helper.getUser().id">
    <div class="empty-page__container">
        <img src="/assets/images/empty-page.png" alt="">
        <span [innerHTML]="'EmptyPage.Description' | translate"></span>
    </div>
</div>